export default __webpack_public_path__ + "static/media/defender-long.15ea18cd.svg";